import { render, staticRenderFns } from "./TalentPackageOptIn.vue?vue&type=template&id=15f3db7c"
import script from "./TalentPackageOptIn.vue?vue&type=script&lang=js"
export * from "./TalentPackageOptIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports